<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">ACKNOWLEDGEMENTS</p>
<p class="noindent-a">Thanks first to the Robinson-Spangler Carolina Room of the Public Library of Charlotte and Mecklenburg County, whose wonderful files gave me a great start and especially to Sheila Bumgarner for her help in gathering many of the photographs. Thanks most of all to Bob for his encouragement and for being a part of my every day.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?32344056